const navigationIssues = [
  {
    title: true,
    name: "Issues",
    class: "",
    wrapper: {
      element: "",
      attributes: {}
    }
  },
  {
    name: "Customer Issues",
    url: "/base/IssuesPreview",
    icon: "icon-pencil"
  },
  {
    name: "Customer Issues Map",
    url: "/base/IssuesMap",
    icon: "icon-map"
  }
];

export default navigationIssues;
